import { useCallback } from "react";
import { useSelector } from "react-redux";

export const useSpinner = () => {
  const spinnerActions = useSelector(
    (state) => state.system.spinnerActions
  );

  // Check whether the request is still running.
  return useCallback(
    (actionType) => spinnerActions.includes(actionType),
    [spinnerActions]
  );
};
